import { render, staticRenderFns } from "./my_class.vue?vue&type=template&id=1f97d92e&scoped=true&"
import script from "./my_class.vue?vue&type=script&lang=js&"
export * from "./my_class.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f97d92e",
  null
  
)

export default component.exports